"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireWildcard(require("react"));

var _Svg = _interopRequireDefault(require("./Svg"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Union = _interopRequireDefault(require("./Union"));

var _Down = _interopRequireDefault(require("./Down"));

var _Jump = _interopRequireDefault(require("./Jump"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

function ChangeData(val, num) {
  if ((0, _typeof2["default"])(val) !== 'object') return true;
  return val === null || val === void 0 ? void 0 : val.map(function (item, index) {
    var pane = (item || {}).pane;

    var _a = pane || {},
        simpleData = _a.simpleData,
        iconsDesc = _a.iconsDesc;

    item.parentId = num || null;
    item.id = "" + (num ? num + "_" + index : index);

    if (simpleData) {
      pane.simpleData = ChangeData(simpleData, item.id);
    }

    if (iconsDesc) {
      pane.iconsDesc = ChangeData(iconsDesc, item.id);
    }

    if (item === null || item === void 0 ? void 0 : item.children) {
      item.children = ChangeData(item.children, item.id);
    }

    return item || {};
  });
}

function Mobile(props) {
  var _a;

  var setRenderChecked = props.setRenderChecked;
  var _b = (props || {}).configuration,
      configuration = _b === void 0 ? [] : _b;
  var datas = ChangeData(configuration);
  var getOneTxt = (_a = datas[0]) === null || _a === void 0 ? void 0 : _a.label;

  var _c = (0, _react.useState)(getOneTxt),
      title = _c[0],
      setTitle = _c[1];

  var _d = (0, _react.useState)(false),
      mainStatus = _d[0],
      setMainStatus = _d[1];

  return /*#__PURE__*/_react["default"].createElement("section", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'm-audio-video-title',
    onClick: function onClick() {
      setMainStatus(!mainStatus);
    }
  }, /*#__PURE__*/_react["default"].createElement("span", null, title), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      display: 'inline-flex'
    }
  }, mainStatus ? /*#__PURE__*/_react["default"].createElement(_Union["default"], null) : /*#__PURE__*/_react["default"].createElement(_Down["default"], null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('audio-video-content', {
      'audio-video-hide': !mainStatus
    })
  }, /*#__PURE__*/_react["default"].createElement(Tree, {
    configuration: datas,
    setMainStatus: setMainStatus,
    mainStatus: mainStatus,
    setTitle: setTitle,
    setRenderChecked: setRenderChecked
  })));
}

function Tree(props) {
  var _a = props || {},
      configuration = _a.configuration,
      setTitle = _a.setTitle,
      setRenderChecked = _a.setRenderChecked,
      _b = _a.child,
      child = _b === void 0 ? 0 : _b,
      setMainStatus = _a.setMainStatus;

  var _c = (0, _react.useState)({}),
      status = _c[0],
      setStatus = _c[1];

  return /*#__PURE__*/_react["default"].createElement("span", {
    className: 'm-audio-video-main-ul'
  }, configuration.map(function (item, index) {
    var _a;

    var _b = item || {},
        jump = _b.jump,
        label = _b.label,
        txt = _b.txt,
        desc = _b.desc,
        bindingNum = _b.bindingNum,
        id = _b.id,
        pane = _b.pane,
        children = _b.children;

    var _c = jump || {},
        href = _c.href,
        icons = _c.icons;

    var _d = pane || {},
        simpleData = _d.simpleData,
        iconsDesc = _d.iconsDesc;

    var _data = simpleData || iconsDesc || children || [];

    return /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])("main-ul__li", (_a = {
        'main-ul__li--show ': !status[id]
      }, _a["h_" + (desc ? 1 : 0)] = !status[id], _a)),
      key: index
    }, href ? /*#__PURE__*/_react["default"].createElement("a", {
      href: href,
      className: "layers d" + child
    }, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        display: 'flex',
        alignItems: 'center'
      }
    }, href ? /*#__PURE__*/_react["default"].createElement("a", {
      href: href
    }, label || txt) : /*#__PURE__*/_react["default"].createElement("span", null, label || txt), /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        position: 'relative',
        left: '16px'
      }
    }, icons ? /*#__PURE__*/_react["default"].createElement(_Jump["default"], {
      opacity: '0.8',
      color: 'white'
    }) : null), desc ? /*#__PURE__*/_react["default"].createElement("span", {
      className: 'desc'
    }, desc) : null), /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])('rotate-svg-init', {
        'rotate-svg': !status[id]
      })
    }, (_data === null || _data === void 0 ? void 0 : _data.length) ? /*#__PURE__*/_react["default"].createElement(_Svg["default"], null) : null)) : /*#__PURE__*/_react["default"].createElement("span", {
      className: "layers d" + child,
      onClick: function onClick() {
        var _a;

        var ch = status;
        ch = __assign(__assign({}, ch), (_a = {}, _a[id] = !ch[id], _a));
        setStatus(ch);
        setTitle === null || setTitle === void 0 ? void 0 : setTitle(label);

        if (item.render) {
          window.scrollTo(0, 0);
          setMainStatus(false);
          setRenderChecked(bindingNum);
        }
      }
    }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("span", null, label || txt), desc ? /*#__PURE__*/_react["default"].createElement("span", {
      className: 'desc'
    }, desc) : null), /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])('rotate-svg-init', {
        'rotate-svg': !status[id]
      })
    }, (_data === null || _data === void 0 ? void 0 : _data.length) ? /*#__PURE__*/_react["default"].createElement(_Svg["default"], null) : null)), (_data === null || _data === void 0 ? void 0 : _data.length) ? /*#__PURE__*/_react["default"].createElement(Tree, {
      setMainStatus: setMainStatus,
      configuration: _data,
      child: child + 1,
      setRenderChecked: setRenderChecked
    }) : null);
  }));
}

var _default = Mobile;
exports["default"] = _default;